import React, { useEffect, useRef, useState } from 'react';
import PageContainer from '../layouts/PageContainer';
import PageHeader from '../components/Nav/PageHeader';
import FiltersBar from '../components/Voucher/FiltersBar';
import VoucherTable from '../components/Voucher/VoucherTable';
import { useVoucher } from '../DataStore/VoucherContext';
import NewVoucher from '../components/Voucher/NewVoucher';
import StarterPanel from '../components/Dashboard/StarterPanel';
import { numberFormat, printContent } from '../util/araknerdlib';
import WifiMetricMiniCard from '../components/Dashboard/WifiMetricMiniCard';
import RevokeVouchersModal from '../components/Voucher/RevokeVouchersModal';
import VoucherCardView from '../components/Voucher/VoucherCardView';


const MetricsRow = ({ activeVouchers, redeemedToday, revenueToday, expiringSoon }) => (
  <div className="d-flex justify-content-end align-items-center py-3 px-4 rounded">
    <WifiMetricMiniCard label="Active Vouchers" value={numberFormat(activeVouchers)} iconColor="text-warning" icon='fas fa-clock'/>
    <div className="border-left mx-3" style={{ height: 30 }} />
    <WifiMetricMiniCard label="Redeemed Today" value={numberFormat(redeemedToday)} iconColor="text-success" icon='fas fa-check-circle'/>
    <div className="border-left mx-3" style={{ height: 30 }} />
    <WifiMetricMiniCard label="Expiring Soon" value={numberFormat(expiringSoon)} iconColor="text-danger" icon='fas fa-clock'/>
  </div>
);

const VoucherMgtPage = () => {
  const { getVoucherStats, voucherStats, getVoucherTransactions, transactions, metaData, filters, setFilters, setCurrentPage, setMounted } = useVoucher();

  const [selected, setSelected] = useState([]);   // selected ids
  const [showManual, setShowManual] = useState(false);
  const [showRevoke, setShowRevoke] = useState(false);
  const [viewMode, setViewMode] = useState('tabular');
  const pageRef = useRef(); // Ref to enclose statement content for printing

  

  useEffect(() => {
    getVoucherStats();
    getVoucherTransactions();
    setMounted(true);
  }, []);

  const onRefresh = () => {
    getVoucherStats(true);
    getVoucherTransactions(true);
    setSelected([]);
  };

  const handleFilter = () => {
    getVoucherTransactions(true);
  };

  const onRowClick = (row) => {
    // TODO: open drawer with voucher details & redemption history
    //alert(`Voucher ${row.code}`);
  };

  return (
    <>
    <PageContainer>
      <PageHeader
        title="Voucher Management"
        breadcrumb={<li className="breadcrumb-item active" aria-current="page">Voucher Management</li>}
        primaryButtons={[
            {
                label: 'New Voucher',
                icon: 'fas fa-plus-circle',
                className: 'btn-success',
                onClick: () => setShowManual(true)
            },
           
    ]}
      dropdown={{
            label: 'Options',
            icon: 'fas fa-cog',
            buttonClass: 'btn-outline-info',
            items: [
              { label: 'Tabular View', icon: 'fas fa-table', onClick: () => setViewMode('tabular') },
              { label: 'Grid View', icon: 'fas fa-th', onClick: () => setViewMode('grid') },
              { label: 'Refresh', icon: 'fas fa-sync', onClick: onRefresh },
              { label: 'Revoke Codes', icon: 'fas fa-ban', onClick: () => setShowRevoke(true) },
              { label: 'Print Vouchers', icon: 'fas fa-print', onClick: () => printContent(pageRef, "Openfi Vouchers") }
            ]
          }}
      />

      <div className="row">
        <StarterPanel greetingText='Hi'/>
        <div className="col-lg-8 mb-4">
          <MetricsRow
            activeVouchers={voucherStats.active}
            redeemedToday={voucherStats.redeemedToday}
            revenueToday={voucherStats.revenueToday}
            expiringSoon={voucherStats.expiringSoon}
          />
        </div>
      </div>


      {viewMode === 'tabular' && <FiltersBar filters={filters} setFilters={setFilters} handleFilter={handleFilter} data={transactions} />}

      {viewMode === 'tabular' ? (
        <VoucherTable
          data={transactions}
          selected={selected}
          setSelected={setSelected}
          onRowClick={onRowClick}
          metaData={metaData}
          setCurrentPage={setCurrentPage}
          onRevoke={() => setShowRevoke(true)}
          ref={pageRef}
        />
      ) : (
        <VoucherCardView
          data={transactions}
          brandTitle="WIFI VOUCHER"
          wifiName="OPENFI PUBLIC WIFI"
          loginUrl="http://10.0.0.1"
          ref={pageRef}
        />
      )}

    </PageContainer>
    <NewVoucher
      show={showManual}
      onClose={() => setShowManual(false)}
      onSuccess={() => {
            setShowManual(false);
            onRefresh();
        }}
    />
    <RevokeVouchersModal
      show={showRevoke}
      onClose={() => setShowRevoke(false)}
      onSuccess={() => {
        setShowRevoke(false);
        onRefresh();
      }}
      codes={selected}
    />
  </>
  );
};

export default VoucherMgtPage;
